module.exports = __webpack_public_path__ + "static/img/doctor.c92cbfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor.png
// module id = QLFm
// module chunks = 1